<template>
    <div class="identity-page">
    <h1> Your Trusted Leader for Roofing in Niles, Michigan</h1>
    <h2>
        H.O.M.E.S Roofing aims to be the leading roofing expert throughout Southwest Michigan.
        Our experienced team of roofing professionals is dedicated to providing the highest quality in residential and commercial roof repairs, replacements, and free inspections. We prioritize excellence and customer satisfaction, ensuring a smooth and hassle-free experience from start to finish. Reach out today for your free, no-obligation estimate!
    </h2>
    </div>
  </template>

  <script>
  export default {
  name: "IdentityPage",
    }
</script>  
  
  <style scoped>
  .identity-page {
    font-family: 'Roboto', sans-serif;
  color: #ffffff;
  line-height: 1.6;
  text-shadow: 2px 2px 0px #000000;
  letter-spacing: 2px;
  background: transparent;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  </style>